export default __webpack_public_path__ + "static/media/img7.1a1a09f6.jpg";